import { CUSTOM_ELEMENTS_SCHEMA, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { PopupService } from 'app/shared/components/popup/popup.service';
import { PopupComponent } from '../../../../shared/components/popup/popup.component';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'app-show-more',
  templateUrl: './show-more.component.html',
  styleUrls: ['./show-more.component.scss'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [PopupComponent, NgStyle],
})
export class ShowMoreComponent {
  @Input() title: string | undefined = '';
  @Input() description: string | undefined = '';
  @Input() imgUrl: string | undefined = '';
  @Input() imgHeight: number = 0;
  @Output() closeEvent = new EventEmitter();
  imgWidth: number;
  paddingTop: number;
  private popupService: PopupService = inject(PopupService);
  constructor() {
    this.imgWidth = 850;
    this.paddingTop = 0;
    this.popupService.open('showMore');
  }

  close() {
    this.popupService.close('showMore');
    this.closeEvent.emit();
  }
}
